import MaterialIconsReact from "material-icons-react";
import React from "react";
import styles from "./Tag.module.css";

function Tag(props) {
  return (    
    <div className={styles.tag + ' ' + styles[props.fillStyle] + ' ' + styles[props.type]}>
      {props.icon && <MaterialIconsReact icon={props.icon} size={12} invert></MaterialIconsReact>}
      <span className={styles.text + ' ft-10'}>{props.children}</span>
    </div>
  );
}

export default Tag;